import api from "./api";

const CLAVE_TOKEN = "sisdet.token";
const CLAVE_USUARIO = "sisdet.usuario";
const CLAVE_SESION = "sisdet.sesion";

export const iniciarSesion = async (usuario, clave) => {
    const respuesta = await api.post("/Token", { user: usuario, password: clave });

    sessionStorage.setItem(CLAVE_TOKEN, respuesta.data.token);
    sessionStorage.setItem(CLAVE_USUARIO, respuesta.data.usuario);
    sessionStorage.setItem(CLAVE_SESION, String(Date.now()));

    // Respaldo en localStorage para sincronizar nuevas pestañas y evitar deslogueos
    localStorage.setItem(CLAVE_TOKEN, respuesta.data.token);
    localStorage.setItem(CLAVE_USUARIO, respuesta.data.usuario);
    localStorage.setItem(CLAVE_SESION, String(Date.now()));

    return respuesta.data.usuario;
};

export const cerrarSesion = () => {
    sessionStorage.removeItem(CLAVE_TOKEN);
    sessionStorage.removeItem(CLAVE_USUARIO);
    sessionStorage.removeItem(CLAVE_SESION);

    localStorage.removeItem(CLAVE_TOKEN);
    localStorage.removeItem(CLAVE_USUARIO);
    localStorage.removeItem(CLAVE_SESION);
};

export const obtenerToken = () => {
    const token = sessionStorage.getItem(CLAVE_TOKEN);
    if (token) return token;
    const localToken = localStorage.getItem(CLAVE_TOKEN);
    if (localToken) {
        sessionStorage.setItem(CLAVE_TOKEN, localToken);
        const localUsuario = localStorage.getItem(CLAVE_USUARIO);
        if (localUsuario) sessionStorage.setItem(CLAVE_USUARIO, localUsuario);
        return localToken;
    }
    return null;
};

export const obtenerUsuario = () => {
    const usuario = sessionStorage.getItem(CLAVE_USUARIO);
    if (usuario) return usuario;
    const localUsuario = localStorage.getItem(CLAVE_USUARIO);
    if (localUsuario) {
        sessionStorage.setItem(CLAVE_USUARIO, localUsuario);
        return localUsuario;
    }
    return null;
};

export const obtenerSesion = () => sessionStorage.getItem(CLAVE_SESION) || localStorage.getItem(CLAVE_SESION);
export const haIniciadoSesion = () => obtenerToken() !== null;

export const getUsuarioByCodigo = async (codigo) => {
    const respuesta = await api.get(`/Usuario/GetUsuarioByCodigo?codigo=${codigo}`);
    return respuesta.data.data;
};
